import axios from 'axios';
//import config from '../../config';
import {envConfig as config} from '../../environment';


axios.interceptors.request.use(function (config) {
   const token = localStorage.getItem("userToken");
   config.headers.Authorization =  token;

   return config;
});

export const getTaleAllApi = async()=>{
   const url = `${config.apiUrl}/v1/tales/`;
   return await axios.get(url)
   .then(response => response.data)
   }

export const getTaleByTaleIdApi = (taleId)=>{
    const url = `${config.apiUrl}/v1/tales/${taleId}`;
    return axios.get(url)
    .then(response => response.data);
 }

 export const getTaleFullByTaleIdApi = (taleId)=>{
   const url = `${config.apiUrl}/v1/tales/full/${taleId}`;
   return axios.get(url)
   .then(response => response.data);
}

 export const getTalesByUserIdApi = (userId)=>{
   const url = `${config.apiUrl}/v1/tales/userId/${userId}`;
   return axios.get(url)
   .then(response => response.data);
}


 export const postSaveTaleApi = (tale)=>{
    const url = `${config.apiUrl}/v1/tales/`;
    return axios.post(url,tale)
    .then(response => response.data);
 }

 export const changeFinalApprovalStatus = (taleId, status)=>{
    const url = `${config.apiUrl}/v1/tales/changeFinalApprovalStatus`;
    return axios.post(url,{taleId, status})
    .then(response => response.data);
 }

 export const updateTaleStatus = (taleId, status)=>{
    const url = `${config.apiUrl}/v1/tales/updateTaleStatus`;
    return axios.post(url,{taleId, status})
    .then(response => response.data);
 }
 
 export const postSaveTaleFullApi = (taleFull)=>{
    const url = `${config.apiUrl}/v1/tales/full`;
    return axios.post(url,taleFull)
    .then(response => response.data);
 }
 export const putUpdateTaleFullApi = (taleFull)=>{
   const url = `${config.apiUrl}/v1/tales/full`;
   return axios.put(url,taleFull)
   .then(response => response.data);
}
export const putUpdateTaleApi = (tale, isApprovedTale = false)=>{
   const url = `${config.apiUrl}/v1/tales/`;
   return axios.put(url,{ins: tale, isApprovedTale})
   .then(response => response.data);
}
export const putUpdateTalePrivateContentApi = (tale, isApprovedTale = false)=>{
   const url = `${config.apiUrl}/v1/tales/changePrivateContent`;
   return axios.put(url,{ins: tale, isApprovedTale})
   .then(response => response.data);
}

export const getTalePDFByTaleIdApi = (taleId)=>{
   const url = `${config.apiUrl}/v1/pdf/tale/${taleId}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob' 
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
         return file;
   });
} 

export const getTaleTextEndPDFByTaleIdApi = (taleId)=>{
   const url = `${config.apiUrl}/v1/pdf/taleTextEnd/${taleId}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob' 
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
         return file;
   });
}



export const postTalesByPropertyApi = (property)=>{
   const url = `${config.apiUrl}/v1/tales/byProperty`;
   return axios.post(url,property)
   .then(response => response.data);
}

export const postTalesBySearchTextApi = (searchText)=>{
   const url = `${config.apiUrl}/v1/tales/search`;
   return axios.post(url,searchText)
   .then(response => response.data);
}
export const postTalesDetailSearchApi = (searchObject)=>{
   const url = `${config.apiUrl}/v1/tales/detailSearch`;
   return axios.post(url,searchObject)
   .then(response => response.data);
}

export const getTaleGroupsFullApi = ()=>{
   const url = `${config.apiUrl}/v1/tales/taleGroupList/full`;
   return axios.get(url)
   .then(response => response.data);
}

export const postTaleListByCriterion = (criterion)=>{
   const url = `${config.apiUrl}/v1/tales/criterion/full`;
   return axios.post(url,criterion)
   .then(response => response.data);
}


export const postTalePDFByCriterionApi = ({criterion})=>{
   const url = `${config.apiUrl}/v1/pdf/tales/criterion/${criterion}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob' ,
      criterion
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
         return file;
   });
}


export const getAdvisoryBoardApprovalAllApi = async()=>{
   const url = `${config.apiUrl}/v1/advisoryBoardApproval/`;
   return await axios.get(url)
   .then(response => response.data)
   }

   export const postAdvisoryBoardApprovalApi = (taObj)=>{
      const url = `${config.apiUrl}/v1/advisoryBoardApproval/`;
      return  axios.post(url,taObj)
      .then(response => response.data)
      }
      export const putAdvisoryBoardApprovalApi = (taObj)=>{
         const url = `${config.apiUrl}/v1/advisoryBoardApproval/`;
         return  axios.put(url,taObj)
         .then(response => response.data)
         }
      
         export const putAdvisoryBoardApprovalBasicApi = (taObj)=>{
            const url = `${config.apiUrl}/v1/advisoryBoardApproval/basic/`;
            return  axios.put(url,taObj)
            .then(response => response.data)
            }
         
   export const postAdvisoryBoardApprovalAddUserAllApi = async(taleIdObj)=>{
      const url = `${config.apiUrl}/v1/advisoryBoardApproval/addAllUser/`;
      return await axios.post(url,taleIdObj)
      .then(response => response.data)
      }
   
export const getAdvisoryBoardApprovalByTaleIdApi = (taleId)=>{
    const url = `${config.apiUrl}/v1/advisoryBoardApproval/byTaleId/${taleId}`;
    return axios.get(url)
    .then(response => response.data);
 }
 export const getAdvisoryBoardApprovalBasicByTaleIdApi = (taleId)=>{
   const url = `${config.apiUrl}/v1/advisoryBoardApproval/byTaleId/basic/${taleId}`;
   return axios.get(url)
   .then(response => response.data);
}

 export const deleteAdvisoryBoardApprovalByIdApi = (abaId)=>{
   const url = `${config.apiUrl}/v1/advisoryBoardApproval/${abaId}`;
   return axios.delete(url)
   .then(response => response.data);
}


 export const getAdvisoryBoardApprovalByUserIdApi = (userId)=>{
   const url = `${config.apiUrl}/v1/advisoryBoardApproval/byUserId/${userId}`;
   return axios.get(url)
   .then(response => response.data);
}

export const getTaleAdvisoryBoardByUserIdPDFApi = (userId)=>{
   const url = `${config.apiUrl}/v1/pdf/tales/advisoryBoard/${userId}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob'    })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
       //  return file;

         const url = window.URL.createObjectURL(file);
         const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "MasalListesi"); //or any other extension
          document.body.appendChild(link);
          link.click();
          
   });
}


export const getTaleEditorAdvisoryBoardCountApi = ()=>{
   const url = `${config.apiUrl}/v1/tales/taleReviewAndAdvisoryBoardList/editorAndAdvisoryBoard`;
   return axios.get(url)
   .then(response => response.data);
}

export const getAboutUsApi = async(lang = "all")=>{
   console.log("getAboutUsApi")
   const url = `${config.apiUrl}/v1/tales/app/aboutUs?lang=${lang}`;
   return await axios.get(url)
   .then(response => response.data);
}

export const getAboutUsApiNew = async(lang = "all")=>{
   console.log("getAboutUsApiNew")
   const url = `${config.apiUrl}/v1/tales/app/aboutUsNew?lang=${lang}`;
   return await axios.get(url)
   .then(response => response.data);
}

export const updateAboutUsApi = async(aboutUsData)=>{
   console.log("updateAboutUsApi")
   const url = `${config.apiUrl}/v1/tales/app/aboutUs`;
   return await axios.post(url, aboutUsData)
   .then(response => response.data);
}

export const updateAboutUsApiNew = async(aboutUsData)=>{
   console.log("updateAboutUsApiNew")
   const url = `${config.apiUrl}/v1/tales/app/aboutUsNew`;
   return await axios.post(url, aboutUsData)
   .then(response => response.data);
}

export const getWithdrawnTaleAllApi = async()=>{
   const url = `${config.apiUrl}/v1/tales/list/withdrawn`;
   return await axios.get(url)
   .then(response => response.data);
}

export const getWithdrawnTaleByUserIdApi = async(userId)=>{
   const url = `${config.apiUrl}/v1/tales/list/withdrawnbyUserId/${userId}`;
   return await axios.get(url)
   .then(response => response.data);
}

export const getNoContractTaleAllApi = async()=>{
   const url = `${config.apiUrl}/v1/tales/list/noContract/`;
   return await axios.get(url)
   .then(response => response.data);
}
export const getNoContractTaleByUserIdApi = async(userId)=>{
   const url = `${config.apiUrl}/v1/tales/list/noContractbyUserId/${userId}`;
   return await axios.get(url)
   .then(response => response.data);
}
export const getRejectErrorTaleAllApi = async()=>{
   const url = `${config.apiUrl}/v1/tales/list/rejectError`;
   return await axios.get(url)
   .then(response => response.data);
}
export const getRejectErrorTaleByUserIdApi = async(userId)=>{
   const url = `${config.apiUrl}/v1/tales/list/rejectErrorbyUserId/${userId}`;
   return await axios.get(url)
   .then(response => response.data);
}
export const getCorrectionRequestedTaleAllApi = async()=>{
   const url = `${config.apiUrl}/v1/tales/list/correctionRequested`;
   return await axios.get(url)
   .then(response => response.data);
}
export const getCorrectionRequestedTaleByUserIdApi = async(userId)=>{
   const url = `${config.apiUrl}/v1/tales/list/correctionRequestedbyUserId/${userId}`;
   return await axios.get(url)
   .then(response => response.data);
}
export const getOtherTalesAllApi = async()=>{
   const url = `${config.apiUrl}/v1/tales/list/otherTales`;
   return await axios.get(url)
   .then(response => response.data);
}
export const getOtherTalesByUserIdApi = async(userId)=>{
   const url = `${config.apiUrl}/v1/tales/list/otherTalesbyUserId/${userId}`;
   return await axios.get(url)
   .then(response => response.data);
}